import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { followUserMutation } from '../../../shared/data/gql/mutation/follow-user.mutation';
import { FollowUserResponse } from '../../../shared/data/responses/follow-user.response';
import { Observable } from 'rxjs';
import { FetchResult } from 'apollo-link';

import { ApolloQueryResult } from 'apollo-client';
import { UnFollowUserResponse } from '../../../shared/data/responses/un-follow-user.response';
import { unFollowUserMutation } from '../../../shared/data/gql/mutation/un-follow-user.mutation';
import { ConnectionQueryInput } from '../../../shared/data/inputs/connection-query.input';
import { getUserFollowersQuery } from '../../../shared/data/gql/query/get-user-followers.query';
import { FollowUnFollowUserInput } from '../../../shared/data/inputs/follow-un-follow-user.input';
import { UserFollowersQueryResponse } from '../../../shared/data/responses/user-followers-query.response';
import { UserFollowingQueryResponse } from '../../../shared/data/responses/user-following-query.response';
import { getUserFollowingQuery } from '../../../shared/data/gql/query/get-user-following.query';
import { MutualFollowingQueryResponse } from '../../../shared/data/responses/mutual-following-query.response';
import { getUserMutualQuery } from '../../../shared/data/gql/query/get-user-mutual.query';
import { SearchUsersInputs } from '../../../shared/data/inputs/search-users.inputs';
import { searchUsersQuery } from '../../../shared/data/gql/query/search-users.query';
import { SearchUsersResponse } from '../../../shared/data/responses/search-users.response';

@Injectable({
  providedIn: 'root'
})
export class ConnectUsersService {
  constructor(private apollo: Apollo) {}

  followUser(
    input: FollowUnFollowUserInput
  ): Observable<FetchResult<FollowUserResponse>> {
    return this.apollo.mutate<FollowUserResponse>({
      mutation: followUserMutation,
      variables: input
    });
  }

  unFollowUser(
    input: FollowUnFollowUserInput
  ): Observable<FetchResult<UnFollowUserResponse>> {
    return this.apollo.mutate<UnFollowUserResponse>({
      mutation: unFollowUserMutation,
      variables: input
    });
  }

  getUserFollowers(
    input: ConnectionQueryInput
  ): Observable<ApolloQueryResult<UserFollowersQueryResponse>> {
    return this.apollo.query<UserFollowersQueryResponse>({
      query: getUserFollowersQuery,
      variables: input
    });
  }

  getUserFollowing(
    input: ConnectionQueryInput
  ): Observable<ApolloQueryResult<UserFollowingQueryResponse>> {
    return this.apollo.query<UserFollowingQueryResponse>({
      query: getUserFollowingQuery,
      variables: input
    });
  }

  getMutualFollowing(
    input: ConnectionQueryInput
  ): Observable<ApolloQueryResult<MutualFollowingQueryResponse>> {
    return this.apollo.query<MutualFollowingQueryResponse>({
      query: getUserMutualQuery,
      variables: input
    });
  }

  searchUsers(
    input: SearchUsersInputs
  ): Observable<ApolloQueryResult<SearchUsersResponse>> {
    return this.apollo.query<SearchUsersResponse>({
      query: searchUsersQuery,
      variables: input
    });
  }
}
